import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import SkuDescription from './components/SkuDescription/SkuDescription'

const BOTRecentlyAddedProductService = ({
  recentlyAddedSku: {
    recentlyAddedSku = []
  } = {},
  seePriceTitle
}) =>
  <Fragment>
    { recentlyAddedSku &&
        recentlyAddedSku.map((sku, index) =>
          <SkuDescription seePriceTitle={ seePriceTitle } key={ index } { ...sku } />)
    }
  </Fragment>

export default BOTRecentlyAddedProductService

BOTRecentlyAddedProductService.propTypes = {
  recentlyAddedSku: PropTypes.shape({
    recentlyAddedSku: PropTypes.arrayOf(PropTypes.object)
  }),
  seePriceTitle: PropTypes.string
}
